const translations = {
  'resources.seo.title': 'Free TEFL Teaching Resources, Materials & Lesson Plans',
  'resources.seo.description': `TEFL Iberia provides free TEFL teaching and material resources. Take a look online and download our resources for free.`,
  'resources.sec1.title': `Resources`,
  'resources.sec1.description': `In this part of the website you’ll find links to many useful resources we’ve discovered on our browsings.`,
  'resources.tab1.text': `English Teaching Jobs`,
  'resources.tab2.text': `English teaching & learning resources`,
  'resources.tab3.text': `Barcelona`,
  'resources.tab4.text': `Seville`,
  'resources.tab1.r1.title': `Jooble`,
  'resources.tab1.r1.text': ` Job search engine – searches all major classified websites for up-to-date job offers.`,
  'resources.tab1.r2.title': `Lingo Bongo`,
  'resources.tab1.r2.text': `Cool name, cool website. Very active for job offers and language exchanges.`,
  'resources.tab1.r3.title': `TEFL Jobs in Spain`,
  'resources.tab1.r3.text': `Jobs section on TEFL.com.`,
  'resources.tab1.r4.title': `Info Jobs`,
  'resources.tab1.r4.text': `Jobs posted for TEFL jobs in Barcelona`,
  'resources.tab1.r5.title': `TEFL Jobs World`,
  'resources.tab1.r5.text': `Jobs, articles and advice for TEFL teachers worldwide.`,

  'resources.tab2.r1.title': `British Council Learning Resources`,
  'resources.tab2.r1.text': ` Lots of quality material from the British Council.`,
  'resources.tab2.r2.title': `Breaking News English`,
  'resources.tab2.r2.text': `Fantastic website, lots of ready-made lesson plans based on current news stories.`,
  'resources.tab2.r3.title': `ITESLJ`,
  'resources.tab2.r3.text': `Another favourite, this one is especially useful for discussion topics. It has an enormous list of every topic you could possible imagine and a huge list of questions to get the discussion flowing between students.`,
  'resources.tab2.r4.title': `Grammar.net`,
  'resources.tab2.r4.text': `Lots of useful tips and fun infographics for learners.`,
  'resources.tab2.r5.title': `Guardian TEFL`,
  'resources.tab2.r5.text': `TEFL section of the Guardian newspaper with articles, resources and news.`,
  'resources.tab2.r6.title': `English Page`,
  'resources.tab2.r6.text': `A fantastic site for both English teachers and learners; has excellent explanations of many grammar points.`,
  'resources.tab2.r7.title': `Tim’s Free English Lesson Plans`,
  'resources.tab2.r7.text': `High quality, communicative lesson plans lovingly crafted by Tim.`,

  'resources.tab3.r1.title': `Barcelona Metropolitan`,
  'resources.tab3.r1.text': `Popular English magazine with a good website the covers monthly happenings in Barcelona.`,
  'resources.tab3.r2.title': `Barcelona LeCool`,
  'resources.tab3.r2.text': `Alternative guide to Barcelona.`,
  'resources.tab3.r3.title': `Barcelona public transport`,
  'resources.tab3.r3.text': `Information about buses, metro and trams in Barcelona.`,
  'resources.tab3.r4.title': `Renfe Cercanias`,
  'resources.tab3.r4.text': `Local commuter train timetable.`,

  'resources.tab4.r1.title': `Not Just a Tourist – Flamenco`,
  'resources.tab4.r1.text': ` Read about the 12 best places to watch flamenco in Seville.`,
  'resources.tab4.r2.title': `Not Just a Tourist – Museums`,
  'resources.tab4.r2.text': `Check out the 8 Best museums in Seville.`,
  'resources.tab4.r3.title': `Ibérico Club`,
  'resources.tab4.r3.text': `Discover what are the 10 best tapas bars in Seville.`,
  'resources.tab4.r4.title': `Visita Seville`,
  'resources.tab4.r4.text': ` Read about Seville’s amazing 28 parks and gardens`,
  'resources.tab4.r5.title': `Seville City Guide`,
  'resources.tab4.r5.text': `Discover Seville’s holidays, events, and festivals.`,
  'resources.tab4.r6.title': `Welcome to Seville`,
  'resources.tab4.r6.text': `Visit the famous flea and street markets in Seville.`,
};

export default translations;
